// extracted by mini-css-extract-plugin
export var content = "DownloadsWallpaperItem-module--content--YukQy";
export var contentImage = "DownloadsWallpaperItem-module--content-image--9e+rD";
export var contentImageInner = "DownloadsWallpaperItem-module--content-image-inner--jsZsx";
export var contentImageRibbon = "DownloadsWallpaperItem-module--content-image-ribbon--AxdUj";
export var contentLinks = "DownloadsWallpaperItem-module--content-links--s5WVt";
export var contentSubTitle = "DownloadsWallpaperItem-module--content-sub-title--2FzZH";
export var contentTitle = "DownloadsWallpaperItem-module--content-title--GKkEr";